import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Sidecar = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="Sidecar Health icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 52"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M37.972829,40.0000268 C37.972829,31.7155105 31.2618581,25.0000604 22.9836461,25.0000604 C14.7050856,25.0000604 7.99446326,31.7155105 7.99446326,40.0000268 L3.99723163,40.0000268 C1.78963872,40.0000268 0,38.2091006 0,35.9999195 L0,12.303112 L64.9533582,12.303112 L64.9533582,35.9999195 C64.9533582,38.2091006 63.164068,40.0000268 60.9564751,40.0000268 L37.972829,40.0000268 Z M51.9626168,22.9998323 L51.9626168,17.9999597 L46.9663387,17.9999597 L46.9663387,22.9998323 L41.9700606,22.9998323 L41.9700606,28.0000537 L46.9663387,28.0000537 L46.9663387,32.9999262 L51.9626168,32.9999262 L51.9626168,28.0000537 L56.9592435,28.0000537 L56.9592435,22.9998323 L51.9626168,22.9998323 Z M64.9533582,6.3027766 L0,6.3027766 L0,3.9997585 C0,1.79057739 1.78963872,0 3.99723163,0 L60.9564751,0 C63.164068,0 64.9533582,1.79057739 64.9533582,3.9997585 L64.9533582,6.3027766 Z M22.9836461,52 C16.3608674,52 10.9922998,46.6275702 10.9922998,40.0000268 C10.9922998,33.3724835 16.3608674,28.0000537 22.9836461,28.0000537 C29.6064249,28.0000537 34.9749924,33.3724835 34.9749924,40.0000268 C34.9749924,46.6275702 29.6064249,52 22.9836461,52 Z M22.9836461,44.9998994 C25.7430501,44.9998994 27.9799242,42.761416 27.9799242,40.0000268 C27.9799242,37.2386377 25.7430501,35.0001543 22.9836461,35.0001543 C20.2238936,35.0001543 17.9870194,37.2386377 17.9870194,40.0000268 C17.9870194,42.761416 20.2238936,44.9998994 22.9836461,44.9998994 Z"
    />
  </svg>
)
